import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { parseCatalog } from "@equipped/core/core/catalog";
import { catalogFields } from "../catalogFields";
import { renderFields } from "../fieldTypes";
import { DocumentPanel } from "./DocumentPanel";

const FIELDS = renderFields(catalogFields);

export function CatalogPanel({
  value,
  onChange,
  onSave,
  onDiscard,
  dirty,
  saving,
  saveError,
  onAddPackEntry,
  onAddCatalogEntry,
}: {
  value: Record<string, unknown>;
  onChange: (next: Record<string, unknown>) => void;
  onSave: () => void;
  onDiscard: () => void;
  dirty: boolean;
  saving: boolean;
  saveError: string | null;
  onAddPackEntry: () => void;
  onAddCatalogEntry: () => void;
}) {
  const entryCount = Array.isArray(value.entries) ? value.entries.length : 0;
  return (
    <DocumentPanel
      title={(value.title as string) || "New catalog"}
      fields={FIELDS}
      value={value}
      onChange={onChange}
      onSave={onSave}
      onDiscard={onDiscard}
      dirty={dirty}
      saving={saving}
      saveError={saveError}
      validate={parseCatalog}
      extra={
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {entryCount} {entryCount === 1 ? "entry" : "entries"} — select one in the tree to edit it, reorder, or remove it.
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button size="small" variant="outlined" onClick={onAddPackEntry}>
              + Add pack entry
            </Button>
            <Button size="small" variant="outlined" onClick={onAddCatalogEntry}>
              + Add catalog entry
            </Button>
          </Box>
        </Box>
      }
    />
  );
}
